import { render, staticRenderFns } from "./NoteSeverityIcon.vue?vue&type=template&id=17fe56f6&"
import script from "./NoteSeverityIcon.vue?vue&type=script&lang=js&"
export * from "./NoteSeverityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports